export const arabicLabels = {
    loading: 'جارٍ التحميل',
    close: 'إغلاق',
    retry: 'إعادة المحاولة',
    loadFailed: 'تعذّر تحميل البيانات',
    noResults: 'لا توجد نتائج',
    actions: 'إجراءات',
    pagination: 'التنقل بين الصفحات',
    previous: 'السابق',
    next: 'التالي',
    range: '{first}–{last} من {total}',
    pageStatus: 'الصفحة {page} من {pages}',
    filters: 'التصفية',
    filtersApplied: '{count} مرشحات مطبّقة',
    filtersPending: 'تغييرات لم تُطبَّق بعد',
    apply: 'تطبيق',
    reset: 'مسح الكل',
    removeFilter: 'إزالة المرشح: {name}',
    copy: 'نسخ',
    copied: 'تم النسخ',
    copyFailed: 'تعذّر النسخ',
    cancel: 'إلغاء',
    confirm: 'تأكيد',
    notifications: 'الإشعارات',
    dismiss: 'إخفاء',
    updating: 'جارٍ التحديث',
    breadcrumbs: 'مسار التنقل',
    chartTable: 'عرض البيانات كجدول',
    chartPoint: '{label}: {value}',
};
export const englishLabels = {
    loading: 'Loading',
    close: 'Close',
    retry: 'Try again',
    loadFailed: 'Could not load this',
    noResults: 'No results',
    actions: 'Actions',
    pagination: 'Pagination',
    previous: 'Previous',
    next: 'Next',
    range: '{first}–{last} of {total}',
    pageStatus: 'Page {page} of {pages}',
    filters: 'Filters',
    filtersApplied: '{count} filters applied',
    filtersPending: 'Changes not applied yet',
    apply: 'Apply',
    reset: 'Clear all',
    removeFilter: 'Remove filter: {name}',
    copy: 'Copy',
    copied: 'Copied',
    copyFailed: 'Could not copy',
    cancel: 'Cancel',
    confirm: 'Confirm',
    notifications: 'Notifications',
    dismiss: 'Dismiss',
    updating: 'Updating',
    breadcrumbs: 'Breadcrumbs',
    chartTable: 'Show the data as a table',
    chartPoint: '{label}: {value}',
};
/** Fills `{name}` placeholders. An unknown placeholder stays visible rather than vanishing. */
export function fill(template, values) {
    return template.replace(/\{(\w+)\}/g, (match, key) => key in values ? String(values[key]) : match);
}
//# sourceMappingURL=labels.js.map